import React from "react";
import { compose, withState, withHandlers } from "recompose";
import PropTypes from "prop-types";
import styled from "styled-components";
import Typography from "../FlexiTypography/index.js";
import CircularProgress from "@material-ui/core/CircularProgress";
import Avatar from "@material-ui/core/Avatar";
import Collapse from "@material-ui/core/Collapse";
import ExpandIcon from "@material-ui/icons/ExpandLess";
import Link from "../FlexiLink/index.js";
import expandArrow from "./Polygon 1arrow.svg";
import { isWidthDown } from "@material-ui/core/withWidth";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import withStyles from "@material-ui/core/styles/withStyles";
import Box from "@material-ui/core/Box/Box";

const Wrapper = withStyles(theme => ({
  root: {
    cursor: "pointer",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    backgroundColor: "inherit",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    position: "relative",
    "&.margin-helper": {
      marginBottom: 0
    },
    "&.border": {
      borderTop: "1px solid grey"
    },
    "& a": {
      textDecoration: "none",
      "&:focus": {
        outline: 0
      },
      "&:visited, &:-webkit-any-link": {
        textDecoration: "none"
      },
      "&:hover": {
        textDecoration: "underline",
        color: "#fff"
      }
    },
    "& svg": {
      fontSize: 28
    },
    // Responsive styles
    [theme.breakpoints.down("sm")]: {
      marginLeft: 15,
      marginBottom: 20,
      display: props => (props.hideOnMobile ? "none" : "flex")
    }
  }
}))(props => <Box {...props} />);

const OuterWrapper = withStyles(theme => ({
  root: {
    "& > div:nth-of-type(1)": {
      height: 50
    },
    [theme.breakpoints.up("md")]: {
      width: 300
    },
    "&:focus": {
      outline: 0
    }
  }
}))(props => <Box {...props} />);

const Expander = withStyles(theme => ({
  root: {
    color: "white",
    width: "1.5rem",
    position: "absolute",
    fontSize: 27,
    transition: "transform 0.2s ease",
    bottom: props => (props.appbarcomponent ? "15px" : "-17px"),
    right: props => (props.appbarcomponent ? "0" : "calc(50% - 5px)"),
    transform: props => `rotate(${props.expanded ? "0deg" : "180deg"})`
  }
}))(ExpandIcon);

const Loader = withStyles({
  root: {
    color: "#fff",
    position: "absolute",
    width: "34px !important",
    height: "34px !important"
  }
})(CircularProgress);

/* eslint-disable */
const AvatarCircle = withStyles(theme => ({
  root: {
    width: props => (props.reduceheight ? 28 : 34),
    height: props => (props.reduceheight ? 28 : 34),
    "& svg": {
      fontSize: props => (props.logoPath ? 28 : 19)
    }
  }
}))(props => <Avatar {...props} />);
/* eslint-enable */

const styles = theme => ({
  root: props => ({
    cursor: "pointer",
    padding: "0 1rem",
    borderRadius: 0,
    "&:hover": {
      background: "grey"
    }
  })
});

const CompanyChooserMenuItem = withStyles(styles)(
  ({
    classes,
    avatarSrc,
    icon,
    name,
    onClick,
    className,
    hideOnMobile,
    width,
    href,
    appbarbgcolor
  }) => (
    <Link style={{ textDecoration: "none" }} to={href}>
      <div
        className={`${classes.root} ${className}`}
        onClick={onClick}
        style={{
          padding: "8px 16px",
          display: "flex",
          alignItems: "center",
          marginLeft: isWidthDown("md", width) ? 0 : undefined
        }}
        {...(hideOnMobile && { style: { display: "none" } })}
      >
        {!icon ? (
          <img
            src={avatarSrc}
            alt={avatarSrc}
            style={{
              width: "28px",
              height: "28px",
              fontSize: "1rem"
            }}
          />
        ) : (
          icon
        )}
        <Typography
          variant="body1"
          style={{ color: "#02BE6F", marginLeft: 10, lineHeight: "1.1" }}
        >
          {name}
        </Typography>
      </div>
    </Link>
  )
);

const ActiveAccount = styled.span`
  position: absolute;
  bottom: -2px;
  right: -3px;
  width: 10px;
  height: 10px;
  border-radius: 100% 100%;
  background-color: #8bc34a;
  border: 1px solid rgb(74, 74, 74);
`;

const CurrentCompany = ({ logoPath, avatarUrl, reduceheight, avatarSrc }) => (
  <Link to={avatarUrl} style={{ display: "flex", position: "relative" }}>
    <AvatarCircle src={logoPath || avatarSrc} reduceheight={reduceheight} />
    {reduceheight && <ActiveAccount />}
  </Link>
);

const FlexiCompanyChooser = ({
  username,
  avatarSrc,
  company,
  chooserOpen,
  companies,
  onCompanySelected,
  handleClick,
  handleAppsClick,
  popoverOnClick,
  toggleAppsOpen,
  appsIconShow,
  appsIconColor,
  anchorEl,
  updateAnchorEl,
  logoPath,
  appbarcomponent,
  appbarbgcolor,
  handleClickAway,
  avatarUrl,
  menuItems,
  newCompanyLink,
  width
}) => (
  <OuterWrapper role="button" tabIndex={0}>
    <Wrapper
      appbarcomponent={appbarcomponent.toString()}
      companies={companies}
      menuItems={menuItems}
    >
      {/* eslint-enable */}
      <CurrentCompany
        logoPath={logoPath}
        avatarUrl={avatarUrl}
        avatarSrc={avatarSrc}
      />
      {username || company ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            marginLeft: "20px",
            width: "100%"
          }}
          onClick={handleClick}
        >
          {company && (
            <Typography
              fontSize={12}
              variant="body1"
              style={{
                fontWeight: "bold",
                color: "#fff",
                lineHeight: "1.1",
                marginBottom: "2px",
                display: "-webkit-box",
                WebkitLineClamp: "2",
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                paddingRight: "24px"
              }}
            >
              {company}
            </Typography>
          )}
          {username && (
            <Link to="/profile-settings/profile-data">
              <Typography
                color="secondary"
                style={{
                  fontSize: "12px",
                  lineHeight: "1",
                  color: "#fff"
                }}
              >
                {username}
              </Typography>
            </Link>
          )}
          {chooserOpen ? (
            <ClickAwayListener
              onClickAway={handleClickAway}
              touchEvent={!isWidthDown("md", width)}
            >
              <Expander
                expandIcon={<img src={expandArrow} alt={expandArrow} />}
                onClick={handleClick}
                expanded={chooserOpen ? chooserOpen.toString() : undefined}
                appbarcomponent={appbarcomponent.toString()}
              />
            </ClickAwayListener>
          ) : (
            <Expander
              onClick={handleClick}
              expanded={chooserOpen ? chooserOpen.toString() : undefined}
              appbarcomponent={appbarcomponent.toString()}
            />
          )}
        </div>
      ) : (
        <Loader />
      )}
    </Wrapper>
    <Collapse
      in={chooserOpen}
      style={{
        backgroundColor: appbarbgcolor || "#fff",
        borderBottomLeftRadius: "5px",
        borderBottomRightRadius: "5px",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
        marginTop: "16px",
        overflow: "scroll",
        maxHeight: "200px"
      }}
    >
      {companies.length > 0 &&
        companies.map((item, i) => {
          return (
            <CompanyChooserMenuItem
              key={`${item.id}-i`}
              avatarSrc={item.logoPath || avatarSrc}
              icon={item.icon}
              hideOnMobile={item.hideOnMobile}
              name={item.name}
              onClick={() => {
                onCompanySelected(item);
                handleClickAway();
              }}
              className={`margin-helper ${item.border && "border"}`}
              href={item.href}
            />
          );
        })}
      {newCompanyLink && (
        <Link to={newCompanyLink} style={{ textDecoration: "none" }}>
          <Typography
            variant="body1"
            style={{
              color: "#02BE6F",
              paddingLeft: "26px",
              lineHeight: "1.1",
              paddingTop: "15px",
              paddingBottom: "15px"
            }}
          >
            + vállalkozás hozzáadása
          </Typography>
        </Link>
      )}
      {menuItems.length > 0 &&
        menuItems.map((item, i) => {
          return (
            <CompanyChooserMenuItem
              key={`${item.id}-i`}
              icon={item.icon}
              hideOnMobile={item.hideOnMobile}
              name={item.name}
              className={`margin-helper ${item.border && "border"}`}
              onClick={() => onCompanySelected(item)}
              href={item.href}
            />
          );
        })}
    </Collapse>
  </OuterWrapper>
);

const enhance = compose(
  withState("chooserOpen", "setChooserOpen", false),
  withState("appsOpen", "setAppsOpen", false),
  withState("anchorEl", "updateAnchorEl", null),
  withHandlers({
    toggleChooser: ({
      companies,
      menuItems,
      setChooserOpen,
      chooserOpen
    }) => () => {
      (Boolean(companies.length) || Boolean(menuItems.length)) &&
        setChooserOpen(!chooserOpen);
    },
    toggleAppsOpen: ({ setAppsOpen, appsOpen }) => () => {
      setAppsOpen(!appsOpen);
    }
  }),
  withHandlers({
    handleClick: ({ toggleChooser }) => () => {
      toggleChooser();
    },
    handleClickAway: ({ setChooserOpen }) => () => {
      setChooserOpen(false);
    },
    handleAppsClick: ({ toggleAppsOpen, updateAnchorEl }) => e => {
      updateAnchorEl(e.target);
      toggleAppsOpen();
    }
  })
);

FlexiCompanyChooser.propTypes = {
  logoPath: PropTypes.string,
  username: PropTypes.string,
  company: PropTypes.string,
  chooserOpen: PropTypes.bool,
  handleClick: PropTypes.func,
  companies: PropTypes.array,
  onCompanySelected: PropTypes.func,
  appbarcomponent: PropTypes.bool,
  menuItems: PropTypes.array,
  newCompanyLink: PropTypes.string,
  avatarSrc: PropTypes.string
};

CurrentCompany.propTypes = {
  logoPath: PropTypes.string,
  reduceheight: PropTypes.bool,
  avatarSrc: PropTypes.string
};

export default enhance(FlexiCompanyChooser);
